import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';

import { LoadingOverlay, Text } from '../../shared/uiComponents';
import { HeaderWrapper } from './helpers';
import { formatClientName } from '../../shared/Helpers/functions';

import Assessment from './Assessment';
import TreatmentPlanning from './TreatmentPlanning';
import BehaviorTreatment from './BehaviorTreatment';
import DirectSupervision from './DirectSupervision';
import BehaviorTreatmentModification from './BehaviorTreatmentModification';
import ParentTraining from './ParentTraining';
import MeetAndGreet from './MeetAndGreet';
import DiscretionarySession from './DiscretionarySession';
import IntroCall from './IntroCall';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getSessionInfo } from '../../redux/State/clientSlice/sessionSlice';
import { clearDrafts } from '../../redux/State/clientSlice/soapNoteSlice';

export const findSoapNoteTamplate = (type: number) => {
	switch (type) {
		case 1:
			return <Assessment />;
		case 2:
			return <TreatmentPlanning />;
		case 3:
			return <BehaviorTreatment />;
		case 4:
			return <DirectSupervision />;
		case 5:
			return <BehaviorTreatmentModification />;
		case 6:
			return <ParentTraining />;
		case 7:
			return <MeetAndGreet />;
		case 8:
			return <MeetAndGreet />;
		case 9:
			return <DiscretionarySession />;
		case 10:
			return <IntroCall />;
		default:
			return null;
	}
};

const SOAPNote = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const { sessionType, client, date } = useSelector((state) => state.session.sessionInfo);
	const supervisor = useSelector((state) => state.soapNote.soapNoteData.supervisor);
	const isLoading = useSelector((state) => state.soapNote.initialLoading);

	useEffect(() => {
		const sessionId = params.get('sessionId');
		if (!sessionId) return;

		dispatch(getSessionInfo(sessionId));
	}, [params, dispatch]);

	useEffect(
		() => () => {
			dispatch(clearDrafts());
		},
		[dispatch],
	);

	return (
		<>
			<LoadingOverlay open={isLoading} title="Loading SOAP Note..." />
			<div className="container" style={{ flexDirection: 'column', maxWidth: '900px' }}>
				<HeaderWrapper className="title marginBottom16">
					<Text title="SOAP Note" type="plg" fontWeight="semiBold" />
					{Boolean(date) && (
						<Text title={`Date: ${dayjs(date).format('MM/DD/YYYY')}`} type="plg" fontWeight="semiBold" />
					)}
					{Boolean(client?.fullName) && <Text title={formatClientName(client.fullName, client.isElc)} fontWeight="semiBold" />}
					{Boolean(supervisor?.id) && (
						<Text title={`Supervisor: ${supervisor?.fullName ?? ''}`} fontWeight="semiBold" />
					)}
				</HeaderWrapper>
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<Text title="Service: " fontWeight="semiBold" />
					<Text title={sessionType.name} />
				</div>
				<div className="marginBottom16" />
				{findSoapNoteTamplate(sessionType.type)}
			</div>
		</>
	);
};

export default SOAPNote;
